import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import tw from "tailwind-styled-components";
import useCartActions from "../hooks/useCartAction";
import useAnalytics from '../hooks/useAnalytics';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { FaCheckCircle, FaStar } from 'react-icons/fa';
import Images from "../Images";
// import axios from 'axios';
// import Config from "../Config";

function ProductItem({ product, inCartQty, cartItemId, onOpenLoginModal, onOpenCartModal }) {
  const user = useSelector((state) => state.UserReducer.user);
  const navigate = useNavigate();
  // console.log('product is inside ProductItem >> ', product);
  // console.log('cart item number is inside PRoductItem>>', inCartQty);
  // console.log('cart item id is inside product items>> ',cartItemId);
  const { addItem, updateItem, removeItem } = useCartActions();
  const { trackProductClick } = useAnalytics();
  const isProcessing = addItem.isLoading || updateItem.isLoading || removeItem.isLoading;
  const [stockError, setStockError] = useState('');

  useEffect(() => {
    // console.log(`Product ${product.id} quantity updated to: ${inCartQty}`);
  }, [inCartQty, product.id]);
  // console.log('product for review >> >>', product)

  const handleAddItem = () => {
    if (!user) {
      // toast.info('Please login/signup to add items to the cart.');
      onOpenLoginModal();
      return;
    }
    if (product.stock_quantity <= 0) {
      setStockError('Out of stock');
      return;
    }
    setStockError(''); // clear error

    addItem.mutate({
      product_id: product.id,
      // variant_id: 3, // Your static variant for testing 
      variant_id: product.variant_id,
      quantity: 1,
    }, {
      onSuccess: () => {
        // toast.success(`${product.name} added to cart!`);
        toast.success(`Item added to cart!`);
        onOpenCartModal();
      },
    });
  };

  const handleIncreaseQty = () => {
    if (!user) {
      onOpenLoginModal();
      return;
    }

    if (inCartQty >= product.stock_quantity) {
      setStockError(`Only ${product.stock_quantity} ${product.stock_quantity === 1 ? 'piece' : 'pieces'} left.`);
      return;
    }
    setStockError('');
    updateItem.mutate({
      id: cartItemId,
      quantity: inCartQty + 1,
    });
  };

  const handleDecrease = () => {
    setStockError('');
    if (inCartQty > 1) {
      updateItem.mutate({
        id: cartItemId,
        quantity: inCartQty - 1,
      });
    } else if (inCartQty === 1) {
      removeItem.mutate(cartItemId);
    }
  };

  const imageUrl =
    product.images?.[0]?.image_url || Images.ImagePlaceholder2;
    // "https://cdn-academyblog.pressidium.com/wp-content/uploads/2020/08/IND-Nike-air-jordan-1-mid-shoe-819x1024.jpg";
  // console.log('img url in porduct item >> .jsx?????????????????>>',product.images?.[0]?.image_url );

  const handleProductClick = () => {
    // Navigate to product page 
    navigate(`/product/${product.id}`, { state: { productData: product } });
    
    // Fire-and-forget tracking request
    trackProductClick(product.id); // Call the tracking function from the useAnalytics hook

  //   try {
  //     await axios.post(`${Config.apiUrl}/analytics/track`, {
  //       product_id: product.id,
  //       action_type: 'product_click'
  //     }, {
  //       // Include token if user is logged in
  //       headers: { Authorization: user?.token ? `Bearer ${user.token}` : '' }
  //     });
  //   } catch (err) {
  //     // Ignore tracking errors in UI so it doesn't disrupt the user experience
  //     console.warn("Tracking failed", err);
  //   }
  };

  return (
    <Card>
      <ImageWrapper onClick={handleProductClick} className="cursor-pointer">
        <ProductImage src={imageUrl} alt={product.name} />
        {product.stock_quantity > 0 ? (
          <StockTag className="bg-green-100 text-green-700 border-green-300">
            In Stock
          </StockTag>
        ) : (
          <StockTag className="bg-red-100 text-red-700 border-red-300 line-through">
            Out of Stock
          </StockTag>
        )}

        <div className="absolute left-1 bottom-1 items-center gap-1 w-fit my-0.5 mx-0 h-5">
          <div className="bg-indigo-100 text-indigo-700 text-xs font-semibold px-1 py-0.5 rounded-full flex items-center gap-1 border border-indigo-300">
            <FaCheckCircle className="w-3 h-3" />
            <span>Verified</span>
          </div>
        </div>
      </ImageWrapper>

      {stockError && (
        <StockErrorText>{stockError}</StockErrorText>
      )}

      <DetailsWrapper>
        <TopRow> {/* Product title & add to cart */}
          <ProductTitle onClick={handleProductClick} className="cursor-pointer hover:text-kuality-dark">{product.name}</ProductTitle>
          <CartSection>
            {inCartQty > 0 ? (
              <QuantityBox>
                <QtyButton onClick={handleDecrease} disabled={isProcessing}>
                  -
                </QtyButton>
                <QtyValue>{isProcessing ? "..." : inCartQty}</QtyValue>
                <QtyButton onClick={handleIncreaseQty} disabled={isProcessing || product.stock_quantity <= 0}>
                  +
                </QtyButton>
              </QuantityBox>
            ) : (
              <AddButton onClick={handleAddItem} disabled={isProcessing || product.stock_quantity <= 0}>
                {/* {isProcessing ? "Adding..." : "Add"} */} Add
              </AddButton>
            )}
          </CartSection>
        </TopRow>
        <span className="flex flex-row gap-1">
          <ProductBrand onClick={handleProductClick} className="cursor-pointer">{product.brand}</ProductBrand>
          <Rating>
            {parseFloat(product.average_rating).toFixed(1)} <FaStar className="w-2.5 h-2.5" />
          </Rating>
        </span>
        <Description onClick={handleProductClick} className="cursor-pointer">{product.description}</Description>

        {/* <Meta>
          <MetaItem>{product.sku}</MetaItem>
          <MetaItem><span className="font-medium">Brand:</span> {product.brand}</MetaItem>
        </Meta> */}
      </DetailsWrapper>
      <Price>
        {product.discount_price ? (
          <>
            <OriginalPrice>₹{parseFloat(product.price).toFixed(2)}</OriginalPrice>
            <DiscountedPrice>₹{parseFloat(product.discount_price).toFixed(2)}</DiscountedPrice>
          </>
        ) : (
          <>
            {/* static condition for edge case handling */}
            <OriginalPrice>₹{(Number(product.price) + 500).toFixed(2)}</OriginalPrice>
            <DiscountedPrice>₹{parseFloat(product.price).toFixed(2)}</DiscountedPrice>
          </>
        )}
      </Price>

    </Card>
  );
}

export default ProductItem;
const ImageWrapper = tw.div`
  w-full relative mb-2
`;

const StockTag = tw.div`
  absolute top-1 right-1 text-xs font-semibold px-0.5 py-0.5 border
`;

const DetailsWrapper = tw.div`
  w-full text-left flex flex-col flex-grow
`;

const TopRow = tw.div`
  flex justify-between items-center gap-2 w-full
`;

const ProductTitle = tw.h3`
  text-base font-semibold text-gray-800 truncate
`;

const ProductBrand = tw.p`
  text-sm text-gray-800
`;
const Rating = tw.span`
  flex flex-row text-sm text-yellow-600 font-semibold items-center gap-0.5
`;

const Description = tw.p`
  text-xs text-gray-600 mb-1 line-clamp-2 flex-grow
`;

const Meta = tw.div`
  text-xs text-gray-500 space-y-1
`;

const MetaItem = tw.p`
  flex items-center gap-1
`;


const Card = tw.div`
relative flex flex-col text-center group p-2 hover:shadow-md transition-shadow duration-300 rounded-lg
`;

const ProductImage = tw.img`
  w-full h-auto aspect-square object-contain
  transform transition-transform duration-300
`;

const ProductName = tw.p`
  font-semibold text-gray-800 text-lg line-clamp-1 mb-1
`;

// const Price = tw.p`
//   text-sm text-gray-500 mb-4
// `;
const Price = tw.p`
  text-sm text-gray-600 w-full text-left

`;

const OriginalPrice = tw.span`
  line-through text-gray-400 mr-1
`;

const DiscountedPrice = tw.span`
  text-black font-bold
`;

const FinalPrice = tw.span`
  font-bold text-gray-700
`;

const CartSection = tw.div`
  flex items-center justify-end flex-shrink-0 
`;

const QuantityBox = tw.div`
  flex items-center justify-between w-14 h-6
  bg-kuality-blue text-white font-bold 
  shadow-md hover:shadow-lg transition-shadow duration-200
`;

const QtyButton = tw.button`
  w-1/3 h-full flex items-center justify-center 
 hover:bg-kuality-dark 
  transition-colors duration-200 mx-1
`;

const QtyValue = tw.span`
  w-full h-full flex items-center justify-center text-sm
`;

const AddButton = tw.button`
  w-12 h-6 bg-white text-kuality-blue border border-kuality-blue 
 font-semibold 
  hover:bg-kuality-blue hover:text-white 
  transition-colors duration-200 
  shadow-sm hover:shadow-md 
  disabled:opacity-50
`;
const StockErrorText = tw.p`
  text-red-600 text-xs font-medium w-full text-center
`;
